var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -4 60 60",
    id: "image",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6aa04e;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #65727f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.067,363.317a2.186,2.186,0,0,0,1.571.365,2.233,2.233,0,0,0,1.406-.806L389.235,352.8a2.218,2.218,0,0,1,3.485.036l5.28,9.327v10.685a1.162,1.162,0,0,1-.33.815,1.106,1.106,0,0,1-.8.338h-33.75a1.11,1.11,0,0,1-.8-0.338,1.166,1.166,0,0,1-.329-0.815v-3.766l5.473-7.48a2.233,2.233,0,0,1,1.42-.89,2.2,2.2,0,0,1,1.628.354Z",
    "data-name": "image copy",
    id: "image_copy",
    transform: "translate(-350 -334)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404,340v40H356V340h48m2-6H354a4,4,0,0,0-4,4v44a4,4,0,0,0,4,4h52a4,4,0,0,0,4-4V338a4,4,0,0,0-4-4h0Z",
    "data-name": "image copy 2",
    id: "image_copy_2",
    transform: "translate(-350 -334)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.f0609cf43b0bc7097218de793dc0501a.svg";
export { ForwardRef as ReactComponent };